import React, { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const AccountDangerZone = ({ redirect = "/", className = "mt-8" }) => {
  const [busy, setBusy] = useState(false);

  const disable = async () => {
    if (!window.confirm("Disable your account? You will be signed out everywhere and cannot log in until an administrator re-enables it. Your data is preserved.")) return;
    setBusy(true);
    try {
      await api.post("/account/disable", {});
      toast.success("Account disabled");
      window.location.href = redirect;
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed to disable account"); setBusy(false); }
  };

  const remove = async () => {
    const typed = window.prompt('This permanently deletes your account. Your personal details are removed, but consultation and legal records are retained as required. Type DELETE to confirm:');
    if (typed === null) return;
    if ((typed || "").trim() !== "DELETE") { toast.error('You must type "DELETE" to confirm.'); return; }
    setBusy(true);
    try {
      await api.post("/account/delete", { confirm: "DELETE" });
      toast.success("Account deleted");
      window.location.href = redirect;
    } catch (e) { toast.error(e?.response?.data?.detail || "Cannot delete account"); setBusy(false); }
  };

  return (
    <div className={`rounded-2xl border border-red-200 bg-red-50/40 p-5 ${className}`} data-testid="account-danger-zone">
      <p className="flex items-center gap-2 text-sm font-bold text-red-700 mb-2">
        <AlertTriangle size={15} /> Danger zone
      </p>
      <div className="divide-y divide-red-100">
        <div className="py-3 flex flex-wrap items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#0A2540]">Disable account</p>
            <p className="text-xs text-slate-500">Temporarily stop access. You can re-enable later.</p>
          </div>
          <Button variant="outline" disabled={busy} onClick={disable}
                  className="border-red-300 text-red-700 hover:bg-red-50 shrink-0" data-testid="account-disable-btn">
            Disable account
          </Button>
        </div>
        <div className="py-3 flex flex-wrap items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-sm font-semibold text-[#0A2540]">Delete account</p>
            <p className="text-xs text-slate-500">Permanently delete your account data. Historical consultation records are retained where required.</p>
          </div>
          <Button variant="destructive" disabled={busy} onClick={remove} className="shrink-0" data-testid="account-delete-btn">
            Delete account
          </Button>
        </div>
      </div>
    </div>
  );
};
